import React from 'react';
import {
  HomeBannerContainer,
  HomeBannerContentBox,
  HomeBannerImageBox,
  HomeBannerImageWrapper,
  HomeBannerOverlay,
} from './HomeStyles';

export const HomeBanner = ({ children }: { children: React.ReactNode }) => {
  return (
    <HomeBannerContainer>
      <HomeBannerOverlay />
      <HomeBannerContentBox>{children}</HomeBannerContentBox>
      <HomeBannerImageWrapper>
        <HomeBannerImageBox />
      </HomeBannerImageWrapper>
    </HomeBannerContainer>
  );
};
